/* The Katha: line icons that draw themselves in when they scroll into view (kh-icon snippet).
   Hover motions live in katha-home.css. Reduced motion: icons simply show. */
(function () {
  if (window.khIcons) return; window.khIcons = 1;

  /* Hand-drawn look: a light wobble on every icon line (SVG turbulence), like a pen on paper */
  function rough() {
    if (document.getElementById('kh-rough')) return;
    var d = document.createElement('div');
    d.setAttribute('aria-hidden', 'true');
    d.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
    d.innerHTML = '<svg width="0" height="0"><filter id="kh-rough" x="-10%" y="-10%" width="120%" height="120%"><feTurbulence type="fractalNoise" baseFrequency="0.03" numOctaves="1" seed="11" result="n"/><feDisplacementMap in="SourceGraphic" in2="n" scale="1.5" xChannelSelector="R" yChannelSelector="G"/></filter></svg>';
    document.body.appendChild(d);
    document.documentElement.classList.add('kh-rough');
  }
  if (document.body) rough(); else document.addEventListener('DOMContentLoaded', rough);


  /* The colour-swatch icon: its three cards walk through every colour we make (A B C, B C D, C D E…) */
  var PALETTE = ['#E9E7E5','#C4BDB7','#A9A4A3','#727372','#4E4B50','#D8B4BC','#C7A46C','#DCB26C','#B8602E','#A1AD98','#6D6B4B','#717262','#ABCEE1','#7293B8','#517AA4','#F0EEE9','#E6E1DB','#C0999A','#9B6B2A','#617F70','#4A5C4C','#35627A','#C7BFB4','#9B9D9B','#7497AE','#CBC0CF','#96ABA2','#E7B9A0','#EBDDA8','#C3D3E1','#A58C75','#766451'];
  var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function paintSwatches() {
    var fans = document.querySelectorAll('svg.kh-icon--colours');
    if (!fans.length) return;
    var step = 0;
    function draw() {
      fans.forEach(function (svg, n) {
        for (var k = 1; k <= 3; k++) {
          var el = svg.querySelector('.kh-c' + k);
          if (el) el.style.fill = PALETTE[(step + n * 5 + (k - 1) * 3) % PALETTE.length];
        }
      });
    }
    draw();
    if (still) return;
    setInterval(function () { if (document.hidden) return; step++; draw(); }, 1100);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paintSwatches); else paintSwatches();

  if (!('IntersectionObserver' in window) || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
  document.documentElement.classList.add('kh-icons-anim');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      var svg = en.target; io.unobserve(svg);
      /* icons in the same row draw one after another */
      var sibs = svg.closest('ul, ol, [data-kp-ben], .kp-bens__grid, .kh-trust__list');
      var i = sibs ? Array.prototype.indexOf.call(sibs.querySelectorAll('svg.kh-icon'), svg) : 0;
      svg.style.setProperty('--kh-d', Math.max(0, i) * 90 + 'ms');
      svg.classList.add('is-drawn');
    });
  }, { threshold: 0.6 });
  function prep(root) {
    (root || document).querySelectorAll('svg.kh-icon:not([data-kh-i])').forEach(function (svg) {
      svg.setAttribute('data-kh-i', '');
      svg.querySelectorAll('path, circle, ellipse, rect, polygon, line, polyline').forEach(function (el) { if (!el.hasAttribute('stroke-dasharray')) el.setAttribute('pathLength', '1'); });
      io.observe(svg);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { prep(); }); else prep();
  /* safety net: if the observer is slow (background tab), anything on or above the screen draws anyway */
  function sweep() {
    document.querySelectorAll('svg.kh-icon[data-kh-i]:not(.is-drawn)').forEach(function (svg) {
      if (svg.getBoundingClientRect().top < innerHeight) { io.unobserve(svg); svg.classList.add('is-drawn'); }
    });
  }
  window.addEventListener('load', function () { setTimeout(sweep, 2500); });
  var t = 0; window.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sweep, 1200); }, { passive: true });
  window.khIconsPrep = prep;
})();
